import type * as React from 'react';

type ActionsContainerType = { startFirstColumn?: boolean };

export const ActionsContainer: React.FunctionComponent<
  ActionsContainerType
> = ({ children, startFirstColumn }) => {
  return (
    <div
      className={`col-span-2 ${
        startFirstColumn ? 'sm:col-start-1' : 'sm:col-start-2 sm:col-span-1'
      }`}
    >
      {children}
    </div>
  );
};
